import Form from "@/views/App/Portal/AssistedLivingCoaching/FirstInterview/Form.vue";
import List from "@/views/App/Portal/AssistedLivingCoaching/Protocol/List.vue";
import FirstAppointmentList from "@/views/App/Portal/AssistedLivingCoaching/InvitationToFirstAppointment/List.vue";
import FinalInterviewForm from "@/views/App/Portal/AssistedLivingCoaching/FinalInterview/Form.vue";
import DocumentsForm from "@/views/App/Portal/AssistedLivingCoaching/IntroductoryDocuments/Form.vue";
import MeetingList from "@/views/App/Portal/AssistedLivingCoaching/MeetingList/List.vue";
import InterimReportList from "@/views/App/Portal/AssistedLivingCoaching/InterimReport/List.vue";
import InvoiceDocumentsForm from "@/views/App/Portal/AssistedLivingCoaching/InvoiceDocuments/Form.vue";
import WeeklyPlanForm from "@/views/App/Portal/AssistedLivingCoaching/WeeklyAndEmergencyPlan/Form.vue";


const routesPortalAssistedLivingCoaching = [
    {
        path: 'first-interview/:id',
        name: 'assistedLivingCoachingFirstInterviewForm',
        component: Form
    },
    {
        path: 'protocol-list/:id',
        name: 'assistedLivingCoachingProtocolList',
        component: List
    },
    {
        path: 'interim-report-list/:id',
        name: 'assistedLivingCoachingInterimReportList',
        component: InterimReportList
    },
    {
        path: 'invitation-to-first-appointment-list/:id',
        name: 'assistedLivingCoachingInvitationToFirstAppointmentList',
        component: FirstAppointmentList
    },
    {
        path: 'final-interview-form/:id',
        name: 'assistedLivingCoachingFinalInterviewForm',
        component: FinalInterviewForm
    },
    {
        path: 'documents-form/:id',
        name: 'assistedLivingCoachingDocumentsForm',
        component: DocumentsForm
    },
    {
        path: 'meeting-list/:id',
        name: 'assistedLivingCoachingCoachingMeetingList',
        component: MeetingList
    },
    {
        path: 'invoice-documents/:id',
        name: 'assistedLivingCoachingCoachingInvoiceDocuments',
        component: InvoiceDocumentsForm
    },
    {
        path: 'weekly-plan/:id',
        name: 'assistedLivingCoachingCoachingWeeklyPlan',
        component: WeeklyPlanForm
    }

];

export default routesPortalAssistedLivingCoaching;